import React from 'react';
import { compose, pure } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import DetailsIcon from '@material-ui/icons/Details';

const styles = {
  leftIcon: {
    padding: '0px 5px'
  }
};

const enhance = compose(pure);

const button = enhance(({ classes, params, onClickAction }) => {
  return (
    <Button color="primary" onClick={() => onClickAction(params)}>
      <DetailsIcon className={classes.leftIcon} />
      詳細
    </Button>
  );
});

export default withStyles(styles)(button);
